export type BroadcastRerunFields = {
  status: string;
  recurrence_type?: number;
};

/** Campaigns stopped (cancelled) or finished one-time runs can be re-run. */
export function canRerunBroadcast(b: BroadcastRerunFields): boolean {
  if (b.status === 'cancelled') return true;
  if (b.status === 'completed' && (b.recurrence_type ?? 0) === 0) return true;
  return false;
}
